<template>
  <v-app id="scrollable" class="background">
    <Loader />
    <div>
      <nav>
        <Navbar
          v-if="!$route.meta.hideNavigation"
          @openSimployer="openSimployer"
        />
      </nav>
      <v-main>
        <v-container fluid>
          <router-view />
        </v-container>
      </v-main>
      <BottomNavigation v-if="!$route.meta.hideNavigation" />
      <Snackbar />

      <SnackbarNoInternet v-model="noInternet" />
      <CookieBar />

      <HMSDialog v-model="showHMSDialog" @save="closeHMSDialog" />

      <CompetenceDialog
        v-model="showCompetencDialog"
        persistent
        showSelected
        subtitle="Årlig oppdatering av dine kurs og sertifikater"
        @save="getProjectsKiosk"
      />

      <ChangeProjectDialog
        v-model="showChangeProjectDialog"
        :projects="projects"
        title="Sjekket inn på prosjekt"
        subtitle="Du er logget inn på flere prosjekter. Velg hvilket prosjekt du vil gå til"
        @click="goToProject"
      />
      <ChangeProjectDialog
        v-model="showChangeProjectKioskDialog"
        :projects="kioskProjects"
        title="Kiosk prosjekter"
        subtitle="Velg hvilket prosjekt du vil gå til!"
        @click="goToProject"
      />
      <UserTimeoutDialog
        v-model="showUserTimeoutDialog"
        icon="mdi-account-convert"
        title="Inaktiv bruker"
        subtitle="Bruker blir logget ut"
        @action="logout"
      />
    </div>
  </v-app>
</template>

<script lang="ts">
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import hubConnection from "@/helpers/hubConnection";
import projectApi from "@/api/projectApi";
import contactApi from "@/api/contactApi";
import contactpersonApi from "@/api/contactpersonApi";
import { logout } from "@/helpers/logout";

import { OnInfotechEventObject } from "@/types/hubConnectionInterface";
import { projObject } from "@/types/projectInterface";

import Navbar from "@/components/shared/navigation/Navbar.vue";
import BottomNavigation from "@/components/shared/navigation/BottomNavigation.vue";
import Snackbar from "@/components/shared/snackbar/Snackbar.vue";
import SnackbarNoInternet from "@/components/shared/snackbar/SnackbarNoInternet.vue";
import Loader from "@/components/shared/loader/Loader.vue";
import notification from "./helpers/notification";
import HMSDialog from "@/components/shared/dialog/HMSDialog.vue";
import CompetenceDialog from "@/components/shared/dialog/CompetenceDialog.vue";
import ChangeProjectDialog from "@/components/shared/dialog/ChangeProjectDialog.vue";
import UserTimeoutDialog from "@/components/shared/dialog/UserTimeoutDialog.vue";
import CookieBar from "@/components/shared/CookieBar.vue";

export default Vue.extend({
  name: "App",

  data: () => ({
    noInternet: false,
    showHMSDialog: false,
    showCompetencDialog: false,
    showChangeProjectDialog: false,
    projects: [] as Array<projObject>,
    showChangeProjectKioskDialog: false,
    kioskProjects: [] as Array<projObject>,
    activityTimeout: null as any,
    timoutTime: 300000,
    showUserTimeoutDialog: false,
    logout,
  }),
  created() {
    this.kioskSetup();
    this.setStandaloneStatus();

    // this.getCurrentProjects();
  },
  mounted() {
    //Show snackbar if no internet connection
    this.internettStatus();
  },
  watch: {
    async profile(value, oldValue) {
      this.getCurrentProjects();
      this.setBookingActive();

      await this.checkHMS(value);
      await this.checkCompetence();

      if (!oldValue) {
        // this.kioskSetup();
        await this.getProjectsKiosk();
      }
      //Only when not in kiosk mode
      if (!this.isKiosk) {
        //Start connection to signalR
        await hubConnection.startConnection(value.id);
        //Listen for event changes
        this.$on("OnInfotechEvent", this.infotechEvent);
        hubConnection.onInfotechEvent(this);
      }
      if (this.isKiosk) {
        //Logout user after x inactive time
        addEventListener("touchstart", this.resetLogoutTimer);
        this.activityTimeout = setTimeout(this.inActive, this.timoutTime);
      }
    },
    $route() {
      //If delete kiosk and go back!
      this.checkKiosk();
    },
  },
  methods: {
    ...mapActions({
      setStandaloneStatus: "shared/setStandaloneStatus",
      setCheckedIn: "shared/setCheckedIn",
      setCourses: "courses/setCourses",
      setIsKiosk: "shared/setIsKiosk",
      setIsStartDialogFinished: "shared/setIsStartDialogFinished",
      setBookingActive: "profile/setBookingActive",
    }),
    async closeHMSDialog() {
      await this.checkCompetence();
      await this.getProjectsKiosk();
    },
    kioskSetup() {
      // kiosk.trysilhus.no og testkiosk.trysilhus.no
      var isKiosk =
        window.origin.toLowerCase().includes("kiosk.trysilhus.no") ||
        window.origin.toLowerCase().includes("testkiosk.trysilhus.no");

      this.setIsKiosk(isKiosk);
      this.checkKiosk();
    },
    checkKiosk() {
      if (this.isKiosk) {
        var projects = JSON.parse(
          (localStorage as any).getItem("kioskProjects")
        );
        if (
          this.$route.name !== "Kiosk" &&
          (!projects || projects?.length === 0)
        ) {
          this.$router.push({ name: "Kiosk" });
        } else if (
          this.$route.name !== "Dashboard" &&
          this.$route.name === "Kiosk" &&
          projects &&
          projects?.length > 0
        ) {
          this.$router.push({ name: "Dashboard" });
        }
      }
    },
    async getProjectsKiosk() {
      //Only when hms and competenc is closed
      if (!this.showHMSDialog && !this.showCompetencDialog && this.isKiosk) {
        var projects =
          JSON.parse((localStorage as any).getItem("kioskProjects")) ||
          ([] as Array<projObject>);

        if (!this.isTrysilhus) {
          var data = [] as Array<projObject>;
          await Promise.all(
            projects.map(async (x) => {
              var access = await projectApi.ueProjectAccess(x.id);
              if (access) {
                data.push(x);
              }
            })
          );
          this.kioskProjects = data;
        } else {
          this.kioskProjects = projects;
        }
        if (this.kioskProjects.length === 1) {
          this.setIsStartDialogFinished(true);
          this.$router.push({
            name: "Project",
            params: { id: this.kioskProjects[0].id.toString() },
          });
        } else if (this.kioskProjects.length > 0) {
          this.showChangeProjectKioskDialog = true;
        } else {
          this.setIsStartDialogFinished(true);
        }
      } else if (
        !this.showHMSDialog &&
        !this.showCompetencDialog &&
        !this.isKiosk
      ) {
        this.setIsStartDialogFinished(true);
      }
    },
    async checkHMS(value) {
      //If hms card nummer or date is not saved
      if (
        value &&
        !this.showHMSDialog &&
        (!value.hmsCardNumber || !value.hmsCardIssuedDate)
      ) {
        const noHmsCard = await contactpersonApi.getUserSetting("noHmsCard");
        if (!noHmsCard) {
          this.showHMSDialog = true;
        }
      } else if (
        value &&
        !this.showHMSDialog &&
        moment(
          moment(value.hmsCardIssuedDate).add(2, "years").format("YYYY-MM-DD")
        ).isBefore(moment().format("YYYY-MM-DD"))
      ) {
        //If date of hms card is expired. Issued + 2 years is expired
        notification.warn("HMS kortnummer er gått ut!");
        this.showHMSDialog = true;
      }
    },
    async checkCompetence() {
      if (!this.showHMSDialog) {
        const cometanceUpdated = await contactpersonApi.getUserSetting(
          "cometanceUpdated"
        );
        if (!cometanceUpdated) {
          this.setCourses();
          this.showCompetencDialog = true;
        } else {
          //Show dialog 2 a year.
          const year = moment().format("YYYY"); //Find this year
          const jan = moment([year]).format(); // 01.01.xxxx this year
          const aug = moment([year, 7]).format(); // 01.08.xxxx this year
          const isBeforeJan = moment(cometanceUpdated).isBefore(jan);
          const isBeforeAug = moment(cometanceUpdated).isBefore(aug);

          //Today is after 01.01.xxxx
          const todayJan = moment().isSameOrAfter(jan);
          //Today is after 01.01.xxxx
          const todayAug = moment().isSameOrAfter(aug);

          if ((isBeforeJan && todayJan) || (isBeforeAug && todayAug)) {
            this.setCourses();
            this.showCompetencDialog = true;
          }
        }
      }
    },
    internettStatus() {
      if (!window.navigator.onLine) {
        this.noInternet = true;
      }
      window.addEventListener("online", () => (this.noInternet = false));
      window.addEventListener("offline", () => (this.noInternet = true));
    },
    async infotechEvent(data: OnInfotechEventObject) {
      if (data.isCheckedIn) {
        this.setCheckedIn(data);
        this.isCheckedInMultiProjects(data.projects);
      } else {
        this.setCheckedIn(data);
        this.showChangeProjectDialog = false;
        notification.info(`Du er nå sjekket ut av prosjektet!`);
      }
    },
    getCurrentProjects() {
      contactApi.getCurrentProjects().then((response: Array<projObject>) => {
        var data = {} as OnInfotechEventObject;
        data.projects = response;

        // data.projects = [
        //   {
        //     id: 549344,
        //     name: "Steinbukken",
        //   },
        //   {
        //     id: 546065,
        //     name: "Linnomgrenda",
        //   },
        // ];

        if (data.projects && data.projects.length > 0) {
          data.isCheckedIn = true;
          this.setCheckedIn(data);
        }

        this.isCheckedInMultiProjects(data.projects);
      });
    },
    isCheckedInMultiProjects(projects: Array<projObject>) {
      if (projects.length > 1) {
        //More then one project! Then show all inn dialog.
        this.projects = projects;
        this.getProjectImage(this.projects);
        this.showChangeProjectDialog = true;
      } else if (projects.length === 1) {
        //Only one project! Go to project
        this.$router.push({
          name: "Project",
          params: { id: projects[0].id.toString() },
        });
      }
    },
    getProjectImage(projects: Array<projObject>) {
      projects.forEach(async (x) => {
        await projectApi.getProjectImage(x.id).then((resp) => {
          this.$set(
            x,
            "defaultImage",
            "data:" + resp.contentType + ";base64," + resp.image
          );
        });
      });
    },
    goToProject(project: projObject) {
      this.setIsStartDialogFinished(true);

      this.$router.push({
        name: "Project",
        params: { id: project.id.toString() },
      });
      this.showChangeProjectDialog = false;
      this.showChangeProjectKioskDialog = false;
    },
    inActive() {
      if ((window as any).winSimployer) {
        (window as any).winSimployer.close();
      }
      this.showUserTimeoutDialog = true;
    },
    resetLogoutTimer() {
      //Remove listner for 30 sek
      removeEventListener("touchstart", this.resetLogoutTimer);
      clearTimeout(this.activityTimeout);
      this.activityTimeout = setTimeout(this.inActive, this.timoutTime);
      //Only set 10 min ones
      if (this.timoutTime === 600000) {
        this.timoutTime = 300000;
      }
      //wait 30 sek before listen to touch
      setTimeout(() => {
        addEventListener("touchstart", this.resetLogoutTimer);
      }, 30000);
    },
    openSimployer() {
      //Set 10 min
      this.timoutTime = 600000;
      this.resetLogoutTimer();
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
      checkedIn: "shared/checkedIn",
      isKiosk: "shared/isKiosk",
      isTrysilhus: "shared/isTrysilhus",
    }),
  },
  components: {
    Navbar,
    BottomNavigation,
    Snackbar,
    SnackbarNoInternet,
    Loader,
    HMSDialog,
    CompetenceDialog,
    ChangeProjectDialog,
    UserTimeoutDialog,
    CookieBar,
  },
});
</script>

<style lang="scss">
.background {
  background: var(--v-bodyBG-base) !important;
}

.v-main {
  margin-top: calc(0px + env(safe-area-inset-top)) !important;
  margin-bottom: calc(0px + env(safe-area-inset-bottom)) !important;
  margin-left: calc(0px + env(safe-area-inset-left)) !important;
  margin-right: calc(0px + env(safe-area-inset-right)) !important;
}
</style>
